import { serviceModel } from "../../../models";
import { getExpirationDateMessage } from "../ClientOnboarding.utils";
export function getLimitedTimeDiscountOfferCalloutTextForService(service) {
  const offer = serviceModel.limitedTimeDiscountOffer(service);
  if (!offer) return null;
  if (offer.IsUntil()) {
    return getExpirationDateMessage(offer.ExpirationDate());
  }
  if (offer.IsWithin()) {
    if (offer.ExpirationDate()) {
      return getExpirationDateMessage(offer.ExpirationDate());
    }
    const expirationDays = offer.ExpirationDays();
    if (!expirationDays) return null;
    return "Discounted rates apply if this proposal is approved within ".concat(expirationDays, " days.");
  }
  return null;
}